export interface CadastroDocument {
  id: string;
  nome_completo: string;
  data_nascimento?: string;
  cpf?: string;
  cnpj?: string;
  telefone?: string;
  ops?: string;
  ifood_uuid?: string;
  nao_aprovado_azumi?: boolean;
  tipo_emissao_nf?: string;
  chave_pix?: string;
  tipo_chave_pix?: string;
  tipo_titularidade_pix?: string;
  ativo?: boolean;
  gateway_pagamento?: string;
  created_at?: string;
}

export interface SearchCadastroParams {
  dbName: string;
  telefone?: string;
  cpf?: string;
  cnpj?: string;
}

export interface SearchCadastroResponse {
  cadastro: CadastroDocument[];
  allOps: Array<{ ops: string }>;
}

export interface UpdateCadastroParams {
  dbName: string;
  id: string;
  nome_completo?: string;
  data_nascimento?: string;
  cnpj?: string;
  ops?: string;
  ifood_uuid?: string;
  ativo?: boolean;
  gateway_pagamento?: string;
}

export interface CadastroEditFormData {
  nome_completo: string;
  data_nascimento: string;
  cnpj: string;
  ops: string;
  ifood_uuid: string;
  ativo: boolean;
  gateway_pagamento: string;
}

export const GATEWAYS_PAGAMENTO = ["fitbank", "transfeera"] as const;

export interface CadastroSearchFormData {
  telefone: string;
  cpfCnpj: string;
}
